import * as React from "react";
const SvgFiRrCarBuilding = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-car-building_svg__a)">
      <path
        fill="#062147"
        d="M24 19.732c0-1.261-.217-2.513-.642-3.7l-.968-2.713A5.01 5.01 0 0 0 17.681 10h-2.362a5.01 5.01 0 0 0-4.709 3.318l-.968 2.714c-.655 1.942-1.5 5.513 1.358 5.952v.516a1.5 1.5 0 1 0 3 0V22h5v.5a1.5 1.5 0 1 0 3 0v-.516a2.27 2.27 0 0 0 2-2.252M15.319 12h2.362a3.01 3.01 0 0 1 2.826 1.991l.36 1.009h-8.734l.36-1.009A3.01 3.01 0 0 1 15.319 12m6.413 8H11.268a.27.27 0 0 1-.268-.268c0-.927.143-1.849.425-2.732H13v1a1 1 0 0 0 2 0v-1h3v1a1 1 0 0 0 2 0v-1h1.575c.282.883.425 1.805.425 2.732a.27.27 0 0 1-.268.268M5 2a3 3 0 0 0-3 3v18a1 1 0 1 1-2 0V5a5.006 5.006 0 0 1 5-5h6a5.006 5.006 0 0 1 5 5v2a1 1 0 0 1-2 0V5a3 3 0 0 0-3-3zm2 3v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1m0 5v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1m0 5v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1m0 5v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1m4-16a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-car-building_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCarBuilding;
